module.exports = "/_next/static/videos/buyer-2-60611db80cd7e3ae08d37cf8e1032a34.mp4";